'use strict';

var _ = require('lodash');
var PricingAnalysisServicesTransformerFactory = function PricingAnalysisServicesTransformerFactory(DataTransformer, momentService) {
  function PricingAnalysisServicesTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'pricing-analysis-services';
    this.targetType = 'pricing-analysis-services';
  }
  PricingAnalysisServicesTransformer.prototype = Object.create(DataTransformer.prototype);
  PricingAnalysisServicesTransformer.constructor = PricingAnalysisServicesTransformer;
  PricingAnalysisServicesTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  PricingAnalysisServicesTransformer.prototype.isCacheable = function () {
    return false;
  };
  PricingAnalysisServicesTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  function sortServices(services) {
    return services.departureTime.valueOf();
  }
  function revertDirection(direction) {
    return direction === 'INBOUND' ? 'OUTBOUND' : 'INBOUND';
  }
  function isTOD(service) {
    var serviceTODProperties = [service.compFareKeyOutboundTOD, service.lowestCompetitorFareTOD];
    if (!service.isOneWay) {
      serviceTODProperties.push(service.compFareKeyInboundTOD);
    }
    return _.every(serviceTODProperties, function (p) {
      return !_.isNil(p);
    });
  }
  function prepareCompCarriersData(service) {
    if (_.isUndefined(service.compFareKey)) {
      return;
    }
    var compFareKeyStrings = service.compFareKey.split('.');
    var carriers = compFareKeyStrings[0].split(',');
    service.compCarrierOutbound = carriers[0];
    service.compCarrierFlightNbrsOutbound = compFareKeyStrings[4].replace('[', '').replace(']', '');
    service.compCarrierFareOutbound = parseFloat(compFareKeyStrings[5].replace('[', '') + '.' + compFareKeyStrings[6].replace(']', ''));
    if (!service.isOneWay) {
      service.compCarrierInbound = carriers[1] || carriers[0];
      service.compCarrierFlightNbrsInbound = compFareKeyStrings[11].replace('[', '').replace(']', '');
      service.compCarrierFareInbound = parseFloat(compFareKeyStrings[12].replace('[', '') + '.' + compFareKeyStrings[13].replace(']', ''));
    }
  }
  function prepareCompCarriersTODData(service) {
    if (_.isUndefined(service.compFareKeyOutboundTOD)) {
      return;
    }
    var outboundTODStrings = service.compFareKeyOutboundTOD.split('.');
    service.compCarrierOutboundTOD = outboundTODStrings[0];
    service.compCarrierFlightNbrsOutboundTOD = outboundTODStrings[4].replace('[', '').replace(']', '');
    service.compCarrierFareOutboundTOD = parseFloat(outboundTODStrings[5].replace('[', '') + '.' + outboundTODStrings[6].replace(']', ''));
    if (!service.isOneWay && !_.isUndefined(service.compFareKeyInboundTOD)) {
      var inboundTODStrings = service.compFareKeyInboundTOD.split('.');
      service.compCarrierInboundTOD = inboundTODStrings[0];
      service.compCarrierFlightNbrsInboundTOD = inboundTODStrings[4].replace('[', '').replace(']', '');
      service.compCarrierFareInboundTOD = parseFloat(inboundTODStrings[5].replace('[', '') + '.' + inboundTODStrings[6].replace(']', ''));
    }
  }
  function transform(service) {
    var serviceIdKey = [service.carrier, service.marketOrigin, service.marketDestination, service.departureDate, service.departureTime, service.pos, service.cabinCode, service.direction].join('-');
    service.departureTime = momentService.of(service.departureTime, momentService.FIELD.PRICING_DEPARTURE_TIME, momentService.FORMAT.TIME_ISO);
    if (typeof service.initialOptimizationTime === 'string') {
      service.initialOptimizationTime = momentService.of(service.initialOptimizationTime, momentService.FIELD.EVENT_TIME_STAMP, momentService.FORMAT.DATE_TIME_MILLISECONDS_ISO);
    }
    service.revertedDirection = revertDirection(service.direction);
    service.displayServiceId = service.serviceId.split('.')[2].split('[')[0];
    service.displayServiceIdKey = [service.displayServiceId, serviceIdKey].join(':');
    service.key = [service.serviceId, service.originalServiceId, service.carrier, service.marketOrigin, service.marketDestination, service.departureDate, service.pos, service.cabinCode, service.direction].join('-');
    prepareCompCarriersData(service);
    service.isTOD = isTOD(service);
    if (service.isTOD) {
      prepareCompCarriersTODData(service);
    }
    return service;
  }
  PricingAnalysisServicesTransformer.prototype.transform = function (data) {
    var domainData = _.get(data, 'domain.flattenedPriceRecommendationDepartureDateServices', []);
    return _.chain(domainData).map(transform).sortBy(sortServices).value();
  };
  return PricingAnalysisServicesTransformer;
};
PricingAnalysisServicesTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = PricingAnalysisServicesTransformerFactory;